import React, { useState } from 'react';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { Alert, Badge, Button, Descriptions, Popconfirm } from 'antd';
import { alertify, handleApiExceptions, printRupee } from '../../../app_methods';
import { PermissionHoc } from "../../HOC";
import { Text1, Text3, Text4, Text5 } from '../../../styles';
import { AccountModal } from '../GST/accounts_modal'
import { CHALLAN_NUMBER_CHOICES, MAJOR_HEAD_CHOICES, MINOR_HEAD_CHOICES, STATUSTYPES } from './constants'
import { PaymentAttemptsDrawer } from './payment_attempts_drawer';
import { connect } from 'react-redux';
import { PaymentBreakupDrawer } from './payment_breakup_detail';

const DirectTaxDetails = (props) => {
    const direct_tax = props.direct_tax || {};
    let user = props.user.user ? props.user.user : ''
    const [isPaying, setIsPaying] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [showVirtualAccountModal, setShowVirtualAccountModal] = useState(false);
    const [isUpdatingSA, setIsUpdatingSA] = useState(false);
    const [showPaymentAttemptsDrawer, setShowPaymentAttemptsDrawer] = useState(false);
    const [showPaymentBreakupDrawer, setShowPaymentBreakupDrawer] = useState(false);

    const PermissableButton = PermissionHoc(Button, null, { is_component: true, fallbackComponent: null })
    
    const processPayment = async (virtual_account_id) => {
        setIsPaying(true);
        if (virtual_account_id == '') {
            setIsPaying(false);
            alertify('Error', "Please select source account.", 'error');
            return;
        }
        const response = await direct_tax.processPayment({ id: direct_tax.id, virtual_account_id: virtual_account_id });
        if (!response.success) {
            handleApiExceptions(response);
            setIsPaying(false);
            props.fetchChallanList();
            setShowVirtualAccountModal(false);
            return;
        }
        props.fetchChallanList();
        setIsPaying(false);
        setShowVirtualAccountModal(false)
    }

    const cancelChallan = async () => {
        setIsCancelling(true)
        const response = await direct_tax.cancel();
        if (!response.success) {
            setIsCancelling(false);
            handleApiExceptions(response);
            return;
        }
        alertify('Success', "Challan is cancelled.", 'success');
        props.fetchChallanList();
        props.onClose()
        setIsCancelling(false)
    }
    const downloadAdvice = async () => {
        setIsDownloading(true);
        const response = await direct_tax.downloadAdvice();
        if (!response.success) {
            setIsDownloading(false);
            handleApiExceptions(response);
            return;
        }
        window.open(response.data.url, "_blank");
        setIsDownloading(false);
    }

    const toggleVirtualAccountModal = (is_edit = false) => {
        setIsUpdatingSA(is_edit);
        setShowVirtualAccountModal(!showVirtualAccountModal)
    }

    const togglePaymentAttemptsDrawer = () => {
        setShowPaymentAttemptsDrawer(!showPaymentAttemptsDrawer);
    }

    const togglePaymentBreakupDrawer = () => {
        setShowPaymentBreakupDrawer(!showPaymentBreakupDrawer);
    }

    const PayNowButton = PermissionHoc(Button, "DIRECT_TAX_CHALLAN_WRITE", {
        is_component: true,
        fallbackComponent: '---',
    });

    const ApproveButton = PermissionHoc(Button, "DIRECT_TAX_CHALLAN_WRITE", {
        is_component: true,
        fallbackComponent: '---',
    });

    const approvePayment = async () => {
        setIsPaying(true);
        let approval_id = direct_tax.current_challan_approval.id
        const response = await direct_tax.approvePayment({ approval_id });
        if (!response.success) {
            setIsPaying(false);
            props.fetchChallanList();
            handleApiExceptions(response);
            return;
        }
        props.fetchChallanList();
        setIsPaying(false);
    }
    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Challan Details</Text1>
                <Text5 copyable>{direct_tax.id}</Text5>
                {["unpaid", "Unpaid", "unapproved", "Unapproved"].includes(direct_tax.status) ?
                    <Popconfirm title="Are you sure you want to cancel this Challan?" okText="Yes" cancelText="No" onConfirm={cancelChallan}>
                        <Button className={'float-right'} type="danger" loading={isCancelling} ghost size='small' disabled={isCancelling}>
                            Cancel
                        </Button>
                    </Popconfirm> : null
                }
            </div>
        )
    };

    const renderBasicDetails = () => {
        return (
            <div className="mt-4">
                <Text3 className="d-block" strong>Basic Details</Text3>
                <Descriptions className='mt-2' title={false} column={1} bordered size="small">
                    <Descriptions.Item label="Challan Number">{direct_tax.challan_number ? CHALLAN_NUMBER_CHOICES[direct_tax.challan_number].label : '---'}</Descriptions.Item>
                    <Descriptions.Item label="Tax Applicable">{direct_tax.major_head ? MAJOR_HEAD_CHOICES[direct_tax.major_head].label : '---'}</Descriptions.Item>
                    <Descriptions.Item label="Tax Type">{direct_tax.minor_head ? MINOR_HEAD_CHOICES[direct_tax.minor_head].label : '---'}</Descriptions.Item>
                    <Descriptions.Item label="Nature of Payment">{direct_tax.nature_of_payment ?
                        <div className='d-flex flex-column'>
                            <Text4 >{direct_tax.nature_of_payment.code} {direct_tax.nature_of_payment.tax_percentage > 0 ? `(${direct_tax.nature_of_payment.tax_percentage}%)` : null} </Text4>
                        </div>
                        : 'NA'}</Descriptions.Item>
                    <Descriptions.Item label="TAN">{direct_tax.tan}</Descriptions.Item>
                    <Descriptions.Item label="PAN">{direct_tax.pan}</Descriptions.Item>
                    <Descriptions.Item label="Pincode">{direct_tax.pincode}</Descriptions.Item>
                    <Descriptions.Item label="State">{direct_tax.state}</Descriptions.Item>
                </Descriptions>
            </div>
        )
    }

    const renderPaymentDetails = () => {
        return (
            <div className="mt-4">
                <Text3 className="d-block" strong>Payment Details</Text3>
                <Descriptions className='mt-2' title={false} column={1} bordered size="small">
                    {/* <Descriptions.Item label="Tax Amount">{printRupee(direct_tax.income_tax)}</Descriptions.Item> */}

                    {/* {direct_tax.education_cess > 0 ? <Descriptions.Item label="Education Cess Amount">{printRupee(direct_tax.education_cess)}</Descriptions.Item> : null}
                    {direct_tax.equilization_levy > 0 ? <Descriptions.Item label="Equilization Levy Amount">{printRupee(direct_tax.equilization_levy)}</Descriptions.Item> : null}
                    {direct_tax.interest > 0 ? <Descriptions.Item label="Interest Amount">{printRupee(direct_tax.interest)}</Descriptions.Item> : null}
                    {direct_tax.penalty > 0 ? <Descriptions.Item label="Penalty Amount">{printRupee(direct_tax.penalty)}{' '}(code:{direct_tax.penalty_code})</Descriptions.Item> : null}
                    {direct_tax.surcharge > 0 ? <Descriptions.Item label="Surcharge Amount">{printRupee(direct_tax.surcharge)}</Descriptions.Item> : null}
                    {direct_tax.other_amount > 0 ? <Descriptions.Item label="Other Amount">{printRupee(direct_tax.other_amount)}</Descriptions.Item> : null}
                    {direct_tax.other_fee > 0 ? <Descriptions.Item label="Other Fee Amount">{printRupee(direct_tax.other_fee)}</Descriptions.Item> : null} */}

                    <Descriptions.Item label="Total Amount">
                        <strong className="mr-2 pl-0"> {printRupee(direct_tax.total_amount)}</strong>
                        <Button className="mr-2 pl-0" onClick={togglePaymentBreakupDrawer} type="link" > View Breakup </Button>
                    </Descriptions.Item>
                    <Descriptions.Item label="Payment Initiated By">
                        {["paid", "Paid"].includes(direct_tax.status) && direct_tax.current_payment_attempt ?
                            (direct_tax.current_payment_attempt.payment_initiated_by ? direct_tax.current_payment_attempt.payment_initiated_by.name : <Text4 style={{ fontStyle: "italic" }}>Not Initiated</Text4>)
                            : <Text4 style={{ fontStyle: "italic" }}>Not Initiated</Text4>}
                    </Descriptions.Item>
                    <Descriptions.Item label="Payment Attempts">
                        <Button className="mr-2 pl-0" onClick={togglePaymentAttemptsDrawer} type="link" > View Payment Attempts </Button>
                    </Descriptions.Item>
                </Descriptions>
            </div>
        )
    }

    const renderApproval = () => {
        return (
            <div className="mt-4">
                <Text3 className="d-block" strong>Approvals</Text3>
                {
                    direct_tax.current_challan_approval ?
                        <Descriptions className='mt-2' title={false} column={1} bordered size="small">
                            <Descriptions.Item label="Checked By">{direct_tax.current_challan_approval.checker ? direct_tax.current_challan_approval.checker.name : '--'}</Descriptions.Item>
                            <Descriptions.Item label="Approved By">{direct_tax.current_challan_approval.approver ? direct_tax.current_challan_approval.approver.name : '--'}</Descriptions.Item>
                        </Descriptions>
                        : <Text4 style={{ fontStyle: 'italic' }}>Approval flow is disabled for this challan.</Text4>
                }
            </div>
        )
    }

    const processPaymentButton = () => {
        return (
            <Descriptions.Item label="Action">
                <PayNowButton loading={isPaying} onClick={() => processPayment(direct_tax.source_account.uuid)} type='primary' disabled={direct_tax.status === "processing"}><><span className="mr-2" dangerouslySetInnerHTML={{ __html: `&#8377;` }} />{direct_tax.status === "processing" ? "Payment in process" : "Pay Now"}</></PayNowButton>
            </Descriptions.Item>
        )
    }

    const SourceAccountButtom = () => {
        return (
            <Descriptions.Item label="Action">
                <PayNowButton loading={isPaying} onClick={() => toggleVirtualAccountModal()} type='primary' disabled={direct_tax.status === "processing"}><><span className="mr-2" dangerouslySetInnerHTML={{ __html: `&#8377;` }} />{direct_tax.status === "processing" ? "Payment in process" : "Pay Now"}</></PayNowButton>
            </Descriptions.Item>
        )
    }
    const renderPaymentButton = () => {
        return (
            <div className="mt-4">

                {
                    ["unpaid", "Unpaid", "unapproved", "Unapproved"].includes(direct_tax.status) ? (
                        <Descriptions className='mt-0' title={false} column={1} bordered size="small">
                            <Descriptions.Item label="Payment Status">
                                {direct_tax.status ? <Badge
                                    color={STATUSTYPES[direct_tax.status.toLowerCase()].color}
                                    text={<Text4>{STATUSTYPES[direct_tax.status.toLowerCase()].label}</Text4>}
                                /> : null}
                            </Descriptions.Item>
                            <Descriptions.Item label="Source Account">
                                {direct_tax.source_account ? <> {direct_tax.source_account.funding_via == 1 ? direct_tax.source_account.virtual_account_number : "Credit Card Account"}
                                    {["unpaid", "Unpaid", "unapproved", "Unapproved"].includes(direct_tax.status) ?
                                        <PermissableButton required_permission="DIRECT_TAX_CHALLAN_WRITE" type="link" style={{ paddingLeft: 10 }} onClick={() => toggleVirtualAccountModal(true)}>Change</PermissableButton> : null}</>
                                    : <Text4 style={{ fontStyle: "italic" }}>Not Selected</Text4>}
                            </Descriptions.Item>
                            {
                                direct_tax.current_challan_approval ?
                                    <>
                                        {direct_tax.current_challan_approval.approver && direct_tax.current_challan_approval.checker && direct_tax.status != "paid" ?
                                            processPaymentButton() :
                                            (
                                                ((user.role == 3 && !direct_tax.current_challan_approval.approver) || user.role == 2 && !direct_tax.current_challan_approval.checker) ?
                                                    <Descriptions.Item label="Action">
                                                        <ApproveButton loading={isPaying} onClick={approvePayment} type='primary'><><span className="mr-2" />{"Approve"}</></ApproveButton>
                                                    </Descriptions.Item>
                                                    : null
                                            )
                                        }

                                    </>
                                    : (["unpaid", "Unpaid"].includes(direct_tax.status) && (user.role || user.is_admin) ?
                                        (!direct_tax.source_account ? SourceAccountButtom() : processPaymentButton())
                                        : null)
                            }
                        </Descriptions>
                    ) : null
                }
                {
                    direct_tax.status === "paid" || direct_tax.status === "Paid" ? (
                        <Alert
                            message={direct_tax.status === 'Paid' || direct_tax.status === "paid" ? 'Challan Paid Successfully' : 'Challan Payment In Process'}
                            description={direct_tax.status === 'Paid' || direct_tax.status === "paid" ? <>Challan has been paid successfully. <PermissableButton required_permission="DIRECT_TAX_CHALLAN_WRITE" loading={isDownloading} className="pr-0" onClick={downloadAdvice} type='link'>Download Advice</PermissableButton></> : <>Challan payment is in process. We will inform you once the payment is successful.</>}
                            type={direct_tax.status === 'Paid' || direct_tax.status === "paid" ? 'success' : 'info'}
                            showIcon
                        />
                    ) : null
                }
            </div>
        )
    }

    return (
        <EaseDrawer
            className="payout-link-details-drawer"
            visible={props.visible}
            onClose={props.onClose}
            hideHeader
            hideFooter
            width={525}
        >
            <div className="mt-3">
                {renderTitle()}
                {renderBasicDetails()}
                {renderPaymentDetails()}
                {renderApproval()}
                {renderPaymentButton()}
                <AccountModal
                    visible={showVirtualAccountModal}
                    toggleVirtualAccountModal={toggleVirtualAccountModal}
                    virtualAccounts={props.user.virtual_accounts}
                    onSubmit={processPayment}
                    fetchChallanList={props.fetchChallanList}
                    loading={isPaying}
                    direct_tax={{ ...direct_tax }}
                    isUpdatingSA={isUpdatingSA}
                    user={props.user}
                />
                <PaymentAttemptsDrawer
                    togglePaymentAttemptsDrawer={togglePaymentAttemptsDrawer}
                    visible={showPaymentAttemptsDrawer}
                    onClose={() => togglePaymentAttemptsDrawer()}
                    direct_tax={direct_tax}
                />
                <PaymentBreakupDrawer
                    togglePaymentBreakupDrawer={togglePaymentBreakupDrawer}
                    visible={showPaymentBreakupDrawer}
                    onClose={() => togglePaymentBreakupDrawer()}
                    direct_tax={direct_tax}
                />
            </div>
        </EaseDrawer>
    )
};

const mapStateToProps = (state) => ({
    current_user: state.userReducer.current_user,
});

const DirectTaxDetail = connect(mapStateToProps, null)(DirectTaxDetails);


export { DirectTaxDetail };